<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rakX9X/tc-custom/9781683357544.jpg?1706801089023" alt="This image is the cover for the book Home Made in the Oven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home Made in the Oven
      </h1>
      <p class="bookDescription body article font2">
        <b>Arranged month by month, more than eighty simple seasonal recipes for dishes you can make in the oven. </b><br/><br/>Every week, Yvette van Boven develops a new oven recipe for her magazine column. The recipes are seasonal, delicious, and most importantly, really simple—and now, they’re collected in her latest cookbook: <i>Home Made in the Oven</i>. <br/><br/>What is van Boven serving up fresh from her oven this time? How about autumnal stuffed Portobello mushrooms, a freshly baked plum pie, or cabbage rolls with caraway and hazelnuts? Alongside the more than eighty recipes you’ll also find her annotated illustrations and photographs of finished dishes. For van Boven, everything belongs in the oven: vegetables, meat, fish, pizza, stews, and of course, sweets! These easy recipes are sure to provide you with plenty of tips, tricks, and inspiration for cooking in your oven.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yvette van Boven
      </h2>
      
      <p class="authorDescription body article">Yvette van Boven is a critically acclaimed cookbook author, freelance recipe writer, and illustrator. She is the host of Holland’s popular cooking show Koken Met van Boven, and is also the culinary editor of Holland’s largest women’s weekly magazine and writes and illustrates a weekly column for the popular arts and culture publication Volkskrant magazine. She lives in Amsterdam and Paris.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cd28557